<div class="modal-header blue">
  <h4 class="modal-title">Add Vendor to user</h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<form [formGroup]="vendorFiltersForm">
  <div class="modal-body flex-container">
    <div class="d-flex mb-3 pb-2" [class.disabled]="isLoading">
      <div class="w-100 mr-3">
        <span class="input-label">Enter Name</span>
        <input
          type="text"
          class="input"
          placeholder="Name"
          formControlName="name"
        />
      </div>

      <button
        class="button-outline w-80px"
        [disabled]="!vendorFiltersForm.valid"
        (click)="doSearch()"
      >
        Search
      </button>
    </div>

    <div
      class="user-groups-table flex-fill"
      infiniteScroll
      (scrolled)="onScroll()"
      [scrollWindow]="false"
    >
      <ng-container *ngIf="applicationsDTO; else loading">
        <table
          class="standart-table"
          *ngIf="applicationsDTO?.length; else empty"
        >
          <thead class="standart-table-header">
            <tr>
              <th>name</th>
              <th>code</th>
              <th>
                <div class="d-flex">
                  <label class="checkbox ml-auto">
                    <input
                      type="checkbox"
                      (change)="toggleAllVendors($event)"
                      [checked]="isAllGroupsChecked"
                    />
                  </label>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let app of applicationsDTO">
              <td>{{ app.description }}</td>
              <td>{{ app.code }}</td>
              <td>
                <div class="d-flex">
                  <label class="checkbox ml-auto">
                    <input
                      type="checkbox"
                      (change)="onCheckboxChange(app)"
                      [checked]="app.checked"
                    />
                  </label>
                </div>
              </td>
            </tr>

            <tr *ngIf="isLoading">
              <td colspan="3">
                <div class="d-flex w-100 h-100">
                  <loader></loader>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="button w-134px ml-auto"
      [disabled]="!checkedApplications.length"
      (click)="addVendors()"
    >
      Add Vendors
    </button>
  </div>
</form>

<ng-template #loading>
  <loader></loader>
</ng-template>

<ng-template #empty>
  <empty-state size="sm" title="No results found"></empty-state>
</ng-template>
